module.exports = __webpack_public_path__ + "static/media/chartGas_48.38b290c3.png";